module.exports = __webpack_public_path__ + "static/yoox-dynamic-format-2-2495681dc0bb53672611fc48bacefe26.mp4";